import React from 'react'
import styles from './MenuMobile.module.scss'
import logo from '../../image/Header/logo.png'

export const MenuMobile = ({onClose, isMenuMobile}) => {

    return (
        <div className={`${isMenuMobile === true ? styles.main : styles.main_open}`}>
            <div className={styles.box}>
                <img className={styles.logo} src={logo} alt = 'логотип'/>
                <button className={styles.button} onClick={onClose} aria-label='закрыть меню'/>
            </div>
            <nav className={styles.nav}>
                    <a className={styles.link} href='#AboutUs' onClick={onClose}>О нас</a>
                    <a className={styles.link} href='#Services' onClick={onClose}>Наши услуги</a>
                    <a className={styles.link} href='#Advantages' onClick={onClose}>Преимущества</a>
                    <a className={styles.link} href='#Photo' onClick={onClose}>Портфолио</a>
                    <a className={styles.link} href='#Voprosy' onClick={onClose}>Вопросы</a>
                    <a className={styles.link} href='#Kontakty' onClick={onClose}>Контакты</a>
            </nav>
        </div>
    );
}
